import { InternIcon } from '../intern/icon';
import { InternText } from '../intern/text';

/**
 * Model definition for TopInfoBox
 */
export interface ContentTopInfoBox {
  __component: 'content.top-info-box';
  id: string;
  alternativeHeadline?: string;
  variant: 'icon';
  size?: 'small' | 'medium';
  items: InternText[];
  icon?: InternIcon;
}

export function isContentTopInfoBox(obj: { __component?: string }): obj is ContentTopInfoBox {
  return obj.__component === 'content.top-info-box';
}
